<template>
  <div data-component-group="line-item-dialog-kb" data-component="add-new">
    <dialog-base
      content-class="add-new-line-item-dialog-kb"
      is-fullscreen
      :is-on="isOn"
      :on-close="onCancel"
    >
      <template v-slot:title>
        <div class="dialog-header">
          <v-icon class="item-close" @click="onCancel"> close </v-icon>
          <div class="item-title">
            <h1>{{ $t('create_new_ad') }}</h1>
          </div>
        </div>
      </template>

      <template v-slot:content>
        <div class="dialog-content">
          <AddLineItemForm
            :order="order"
            :line-item="{}"
            :promoted-deal="{}"
            :is-on="isOn"
            :on-cancel="onCancel"
            :on-submit="onConfirm"
          />
        </div>
      </template>
    </dialog-base>
  </div>
</template>

<script>
  import AddLineItemForm from '../../forms/line/AddNewKB';

  export default {
    components: {
      AddLineItemForm,
    },
    props: {
      order: {
        type: Object,
        required: true,
      },
      isOn: {
        type: Boolean,
        default: false,
      },
      onCancel: {
        type: Function,
        required: true,
      },
      onConfirm: {
        type: Function,
        required: true,
      },
    },
  };
</script>

<style lang="scss">
.add-new-line-item-dialog-kb.modal > .modal__backdrop > .modal__content {
  width: 100%;
  background-color: #eceff1;

  .v-theme--dark & {
    background-color: rgb(var(--v-theme-background));
  }

  .dialog-header {
    padding: 0;
    width: 100%;
    display: flex;

    .item-title {
      padding: 28px 12px;
      color: white;

      h1 {
        font-size: 24px;
      }
    }

    .item-close {
      margin: 30px;
      color: white;
      display: block;
      height: 24px;
      width: 24px;
      min-height: 24px;
      min-width: 24px;
    }
  }

  > .modal__body {
    display: flex;
    justify-content: center;

    .dialog-content {
      margin: 40px 0;
      padding: 0;
      width: 650px;
      height: calc(100vh + 156px);
    }
  }
}
</style>
